import { Link } from 'react-router-dom';

export const PaymentPromoBanner = () => {
  return (
    <div className="md:px-4 lg:px-0 mb-2">
      {/* Mobile Layout */}
      <div className="lg:hidden bg-[#FFEF88] rounded-2xl relative overflow-hidden min-h-[200px]">
        <div className="p-6 font-duplet pr-24">
          <h3 className="text-2xl font-bold text-[#222224] mb-2">
            Pay <span className="text-[#F05929]">35%</span> and spread balance
            up to 12 months
          </h3>
          <p className="text-sm text-[#222224] opacity-80 mb-4">
            Start with a small downpayment and enjoy flexible monthly
            installments that fit your budget.
          </p>
          <Link
            to="/sign-up"
            className="bg-[#222224] text-white px-8 py-3 rounded-lg text-sm font-semibold hover:bg-[#333333] transition-colors inline-block"
          >
            Start now
          </Link>
        </div>
        {/* Image positioned at bottom right */}
        <div className="absolute bottom-0 right-0">
          <img
            src="/images/woman-shopping-mobile.min.svg"
            alt="Woman shopping"
            className="w-24 h-auto"
            loading="lazy"
          />
        </div>
      </div>

      {/* Desktop Layout */}
      <div className="hidden lg:block relative overflow-hidden">
        <div className="bg-[#FFEF88] rounded-2xl flex justify-between items-stretch">
          <div className="p-6 font-duplet lg:p-6 grow flex flex-col lg:flex-row items-center justify-between gap-6">
            {/* Left Content */}
            <div className="flex-1 z-10">
              <h3 className="text-2xl lg:text-3xl font-bold text-[#222224] mb-2">
                Pay <span className="text-[#F05929]">35%</span> and spread
                balance up to 12 months
              </h3>
              <p className="text-sm lg:text-base text-[#222224] opacity-80">
                Start with a small downpayment and enjoy flexible monthly
                installments that fit your budget.
              </p>
            </div>

            {/* Center Button */}
            <div className="z-10">
              <Link
                to="/sign-up"
                className="bg-[#222224] text-white px-8 py-3 rounded-lg text-sm font-semibold hover:bg-[#333333] transition-colors inline-block"
              >
                Start now
              </Link>
            </div>
          </div>
          {/* Right Image */}
          <div className="flex-shrink-0">
            <img
              src="/images/woman-shopping.min.svg"
              alt="Woman shopping"
              className="h-full w-auto object-cover"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
